import Vue from "vue";
import Vuex from "vuex";
/**
 * * Vuex Modules
 */
import SimulationModule from "./modules/simulation";
import MSAuthModule from "./modules/msAuth";
import AuthenticationModule from "./modules/authentication";
import SpinnerModule from "./modules/spinnerModule";
import CotationModule from "./modules/cotation";
import VehicleModule from "./modules/vehicle";
import ProposalsModule from "./modules/proposals";
import FormModule from "./modules/formModule";
import UserBkoFormModule from "./modules/userBackofficeForm";
import EntityBkoFormModule from "./modules/entityBackofficeForm";
import GroupBackofficeModule from "./modules/groupBackofficeModule";
import CompanyBkoFormModule from "./modules/companyBackofficeForm";
import FinancialRateOfSiteBkoFormModule from "./modules/financialRateOfSiteBackofficeForm";
import FinancialsBkoFormModule from "./modules/financialBackofficeForm";
import FinancialDataModule from "./modules/financialData";
import InsurancesBkoFormModule from "./modules/insuranceBackofficeForm";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {},
  modules: {
    SimulationModule,
    MSAuthModule,
    AuthenticationModule,
    SpinnerModule,
    CotationModule,
    VehicleModule,
    ProposalsModule,
    FormModule,
    UserBkoFormModule,
    EntityBkoFormModule,
    FinancialRateOfSiteBkoFormModule,
    GroupBackofficeModule,
    CompanyBkoFormModule,
    FinancialsBkoFormModule,
    FinancialDataModule,
    InsurancesBkoFormModule
  },
});
